import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
  Divider,
  Tooltip,
  CircularProgress,
  Fade,
  Tabs,
  Tab,
} from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getDefaultDateTime } from '../common/AppUtils';

import { httpRequest } from '../api/helper';
import CustomTable from '../components/CustomTable';
import { useNotification } from '../context/NotificationContext';
import { API_ERROR_MESSAGE, NA_LABEL } from '../common/AppConstants';

const LOAD_STATS_API = 'time-table/template/load-stats/';
const TABS = [
  { key: "staff", label: "Staff" },
  { key: "classroom", label: "Classroom" },
];

const tableColumns = [
  {
    attr: 'label',
    editable: false,
    extra: false,
    label: 'Name',
    related: false,
    required: false,
    type: 'text',
    help_text: 'Name',
  },
  {
    attr: 'workload',
    editable: false,
    extra: false,
    label: 'Workload',
    related: false,
    required: false,
    type: 'text',
    help_text: 'Workload',
  },
]

export default function LoadStatsModal({
  open,
  handleClose,
}) {
  const { addNotification } = useNotification();
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [selectedTab, setSelectedTab] = useState("staff");

  useEffect(() => {
    const fetchData = async () => {
      refreshData();
    };
    if(open) {
      fetchData();
    }
  }, [open]);

  const refreshData = async (event) => {
    setLoading(true);

    await httpRequest({
      method: 'GET',
      url: LOAD_STATS_API,
      onSuccess: (data) => {
        setData(data);
      },
      onFailure: (data) => {
        setData({});
      },
      addNotification,
    });

    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
        <Typography variant="h3">WorkLoad</Typography>
        <IconButton edge="end" onClick={handleClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      
      <DialogContent sx={{ pt: 0.25, pb: 4 }}>
        <Tabs
          value={selectedTab}
          onChange={(e, newValue) => setSelectedTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 2 }}
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.key}
              value={tab.key}
              label={tab.label}
              sx={{ textTransform: "none", fontWeight: 500, py: 0 }}
            />
          ))}
        </Tabs>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            mb: 1,
            gap: 2,
          }}
        >
          { isLoading ? (
            <CircularProgress size={50} thickness={3} />
          ) : (
            <CustomTable
              columns={tableColumns}
              rows={data[selectedTab] || []}
              relatedData={{}}
              onEdit={undefined}
              allowSorting={true}
              showPagination={false}
            />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
